export default __webpack_public_path__ + "static/media/Shampoo_Grand_mellow.3c719cef.png";